import { _injectGlobalProviders } from "@/domains/styling/global-styles";
import { FloatingTree } from "@floating-ui/react";
import React, { ReactNode, useEffect, FC } from "react";

export interface AtlasGlobalProviderProps {
  children: ReactNode;
}

export const AtlasGlobalProvider: FC<AtlasGlobalProviderProps> = ({ children }) => {
  useEffect(() => {
    _injectGlobalProviders();
  }, []);

  return <FloatingTree>{children}</FloatingTree>;
};
